export default __webpack_public_path__ + "static/media/cabinetdoorbefore.2221d5b6.jpg";